"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const emotion_1 = require("emotion");
const prop_types_1 = __importDefault(require("prop-types"));
const FlexBox_1 = __importDefault(require("../FlexBox"));
const colors_1 = require("../colors");
const droppableStyle = emotion_1.css({
    borderRadius: '3px',
    padding: '8px',
    minHeight: '64px',
});
const Droppable = ({ children, droppableId, isEmpty = false, emptyPlaceholder }) => (react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: droppableId }, (provided, snapshot) => (react_1.default.createElement("div", { ref: provided.innerRef, className: emotion_1.cx('droppable', droppableStyle), style: {
        backgroundColor: snapshot.isDraggingOver ? colors_1.horizon : '',
        border: isEmpty ? `2px dashed ${colors_1.ocean.base}` : '',
    } },
    react_1.default.createElement(FlexBox_1.default, { isVertical: true, paddingY: "s", middle: isEmpty }, !isEmpty ? (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        provided.placeholder))
        : (react_1.default.createElement(react_1.default.Fragment, null, emptyPlaceholder)))))));
Droppable.propTypes = {
    children: prop_types_1.default.node,
    droppableId: prop_types_1.default.string,
    isEmpty: prop_types_1.default.bool,
    emptyPlaceholder: prop_types_1.default.node,
};
exports.default = Droppable;
